import React, { useState, useRef, useEffect } from 'react';
import { Establishment } from 'services/auth/getEstablishments';
import { FiX } from 'react-icons/fi';

import {
  BoxOptions,
  BoxTextOptions,
  TextOptions,
  NotFoundMessage,
} from './styles';

interface Props {
  establishments: Establishment[];
  className?: string;
  setValue(estabishment: Establishment): void;
  value: Establishment | null;
}

const Establishments: React.FC<Props> = ({
  establishments,
  setValue,
  value,
}) => {
  const [search, setSearch] = useState('');
  const [filterText, setFilterText] = useState('');
  const [showOptions, setShowOptions] = useState(false);
  const inputRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (value === null) return;
    setSearch(value.client_group);
    setFilterText('');
  }, [value]);

  const filteredOptions = filterText
    ? establishments.filter(
        option =>
          option.client_group
            .toLowerCase()
            .includes(filterText.toLowerCase()) ||
          option.name.toLowerCase().includes(filterText.toLowerCase()) ||
          option.cnpj.toLowerCase().includes(filterText.toLowerCase()),
      )
    : establishments;

  const handleFocus = () => {
    setShowOptions(true);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        inputRef.current &&
        !inputRef.current.contains(event.target as Node)
      ) {
        setShowOptions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <BoxOptions ref={inputRef}>
      <div>
        <input
          type="text"
          value={search}
          placeholder="Selecione um canal"
          onChange={e => {
            const inputValue = e.target.value;
            setSearch(inputValue);
            setFilterText(inputValue);
            setShowOptions(true);
          }}
          onFocus={handleFocus}
        />
        {search && (
          <FiX
            onClick={() => {
              setSearch('');
              setFilterText('');
              setShowOptions(true);
            }}
            style={{
              position: 'absolute',
              right: '8px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              color: '#999',
            }}
          />
        )}
      </div>

      {showOptions && (
        <BoxTextOptions>
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option, index) => (
              <TextOptions
                key={index}
                onClick={() => {
                  setValue(option);
                  setSearch(option.client_group);
                  setFilterText('');
                  setShowOptions(false);
                }}
              >
                {option.client_group + ' ' + option.cnpj}
              </TextOptions>
            ))
          ) : (
            <NotFoundMessage>Nenhuma opção encontrada</NotFoundMessage>
          )}
        </BoxTextOptions>
      )}
    </BoxOptions>
  );
};

export default Establishments;
